export enum TypeMethodConstantEnum  {
	POST = 'POST',
	GET = 'GET',
	PUT = 'PUT',
	UPDATE = 'UPDATE',
	DELETE = 'DELETE',
	PATCH = 'PATCH',
	OPTIONS = 'OPTIONS',
}